/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stars_AriaInputs */

const es_landing_stars_aria = /** @type {(inputs: Landing_Stars_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de 5 estrellas`)
};

const gl_landing_stars_aria = /** @type {(inputs: Landing_Stars_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de 5 estrelas`)
};

const en_landing_stars_aria = /** @type {(inputs: Landing_Stars_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 out of 5 stars`)
};

/**
* | output |
* | --- |
* | "5 out of 5 stars" |
*
* @param {Landing_Stars_AriaInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_stars_aria = /** @type {((inputs?: Landing_Stars_AriaInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stars_AriaInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_stars_aria(inputs)
	if (locale === "en") return en_landing_stars_aria(inputs)
	return es_landing_stars_aria(inputs)
});